import React from "react";
import {Research} from "../components";
import "./../App.css";
const Research_page = () => {
  return (
    <div>
     <Research />
      
    </div>
  );
};

export default Research_page;
